module.exports = __webpack_public_path__ + "img/exterior_3.8bbbbbab.jpg";